exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-widget=AemButtonChat].is-loading--big {\n  min-height: 0;\n}\n", ""]);

// exports
